import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

/**
 * Layout component that wraps pages with Navbar and Footer
 * Use this for all authenticated user pages to maintain consistent structure
 */
const Layout = ({ children, showFooter = true }) => {
  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      <Navbar />
      <main className="flex-grow">
        {children}
      </main>
      {showFooter && <Footer />}
    </div>
  );
};

export default Layout;
